<template>
	<div class="pop-main flex-row">
		<div class="table-pannel">
			<div class="title">跟单记录{{fid}}</div>
			<el-table :data="followList" border
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
				<el-table-column prop="uid" label="用户信息" align="center" width="140">
					<template slot-scope="scope">
						{{scope.row.nickname}}({{scope.row.uid}})
					</template>
				</el-table-column>
				<el-table-column prop="orderSn" label="订单号" align="center" width="160">
				</el-table-column>
				<el-table-column prop="total_money" label="跟单金额" align="center" width="80">
					<template slot-scope="scope">
						{{scope.row.amount}}元
					</template>
				</el-table-column>
				<el-table-column prop="award" label="奖金" align="center" width="80">
				</el-table-column>
				<el-table-column prop="commission" label="跟单佣金" align="center" width="80">
				</el-table-column>
				
				<el-table-column prop="total_money" label="真/虚" align="center" width="100">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.v==0" size="mini">真</el-tag>
						<el-tag type="danger" v-if="scope.row.v==1" size="mini">虚</el-tag>
					</template>
				</el-table-column>
				
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
				<el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		<div class="task-box">
			<div class="task-form-pannel">
				<div class="title">添加任务</div>
				
				<div class='form-line'>
					<div class='form-name'>跟单人数：</div>
					<el-input size="small" type="number" v-model="form.numbers" class='form-inp'></el-input>
					<div>人</div>
				</div>
				<div class='form-line'>
					<div class='form-name'>跟单金额：</div>
					<el-input size="small" type="number" v-model="form.amounts" class='form-inp'></el-input>
					<div>总跟单金额（元）</div>
				</div>
				<div class='form-line'>
					<div class='form-name'>任务时长：</div>
					<el-input size="small" type="number" v-model="form.times" class='form-inp'></el-input>
					<div>分钟<span style="color:red;">(等于0立即全部完成)</span></div>
				</div>
				<div class='form-line' style="margin: 10px 0;">
					<el-button type="primary" style="width: 280px; margin-top: 10px;" @click="submitAdd()">立即创建</el-button>
				</div>
			</div>
			<div class="task-form-pannel">
				<div class="title">历史任务</div>
				<el-table :data="taskList" border
					v-loading="loading"
					element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(0, 0, 0, 0.8)" >
					<el-table-column prop="id" label="ID" align="center" width="70">
					</el-table-column>
					<el-table-column prop="amounts" label="跟单金额" align="center">
						<template slot-scope="scope">
							{{scope.row.cur_amount}}/{{scope.row.amounts}}
						</template>
					</el-table-column>
					<el-table-column prop="numbers" label="跟单人数" align="center" >
						<template slot-scope="scope">
							{{scope.row.cur_number}}/{{scope.row.numbers}}
						</template>
					</el-table-column>
					<el-table-column prop="times" label="时长" align="center" >
					</el-table-column>
					<el-table-column prop="status" label="任务状态" align="center" width="100">
						<template slot-scope="scope">
							<el-tag type="primary" v-if="scope.row.status==0" size="mini">进行中</el-tag>
							<el-tag type="success" v-if="scope.row.status==1" size="mini">已完成</el-tag>
							<el-tag type="danger" v-if="scope.row.status==2" size="mini">已终止</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="操作" align="center" width="90">
						<template slot-scope="scope">
							<el-tag type="danger" size="mini" @click="stopTask(scope)">终止</el-tag>
						</template>
					</el-table-column>
				  </el-table>
				  </div>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		props:['fid'],
		data(){
			return {
				followList:[],
				taskList:[],
				loading:false,
				currentPage:1,
				limit:10,
				total:0,
				form:{
					numbers:'',
					amounts:'',
					times:''
				}
			}
		},
		mounted() {
			this.getPopularData();
		},
		methods:{
			stopTask(scope){
				if(scope.row.status != 0){
					return;
				}
				let _this = this;
				_this.$api.post("/Virtuals/stopPopularTask", {id:scope.row.id}).then(res=>{
					if(res.code == 200){
						_this.getPopularData();
						_this.$message({type:'success', message:'操作成功'});
					}else{
						_this.$message({type:'error', message:res.msg});
					}
				}).catch(err=>{
					_this.$message({type:'error', message:'操作失败'});
				})
			},
			submitAdd(){
				if(this.fid < 0){
					return this.$message({type:'warning', message:'跟单id不存在，请关闭本弹窗后再试!'});
				}
				if(this.form.numbers <= 0){
					return this.$message({type:'warning', message:'请填写跟单人数'});
				}
				if(this.form.amounts <= 0){
					return this.$message({type:'warning', message:'请填写跟单金额'});
				}
				if(this.form.times < 0){
					return this.$message({type:'warning', message:'请填写任务时长'});
				}
				let _this = this;
				_this.$api.post("/Virtuals/createPopularTask", {fid:_this.fid, ..._this.form}).then(res=>{
					if(res.code == 200){
						_this.currentPage = 1;
						_this.getPopularData();
						_this.$message({type:'success', message:'创建成功'});
					}else{
						_this.$message({type:'error', message:res.msg});
					}
				}).catch(err=>{
					_this.$message({type:'error', message:'创建失败'});
				})
			},
			getPopularData(){
				let _this = this;
				_this.$api.post("/Virtuals/getPopularData", {page:_this.currentPage, limit:_this.limit, fid:_this.fid}).then(res=>{
					if(res.code == 200){
						_this.followList = res.data.followList;
						_this.taskList = res.data.taskList;
						_this.total = res.data.total;
					}else{
						_this.$message({type:'error', message:'数据异常'});
					}
				}).catch(err=>{
					_this.$message({type:'error', message:'数据异常'});
				})
			},
			handleSizeChange(e){
				this.limit = e;
				this.getPopularData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getPopularData();
			}
		}
	}
</script>
<style scoped lang="scss">
	.flex-row {
		display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;
	}
	.pop-main {
		height: 800px;
	}
	.task-box {
		
		width: 640px;
		.task-form-pannel {
			background-color: #f1f1f1;
			margin-bottom: 20px;
			padding: 10px 20px 10px 20px;
			border-radius: 6px;
			.title {
				color: orangered;
				height: 30px;
				line-height: 30px;
				font-size: 16px;
			}
			.form-line {
				margin: 10px 0;
				display: flex; flex-direction: row; align-items: center;
				.form-name {
					width: 80px;
					font-size: 14px;
				}
				.form-inp {
					width: 200px;
					margin-right: 10px;
				}
				.avatar {
					width: 60px; height: 60px; border-radius: 60px;
					margin-right: 10px;
				}
			}
		}
	}
	.table-pannel {
		background-color: #f1f1f1;
		width: 680px;
		padding: 10px;
		border-radius: 6px;
		.title {
			color: orangered;
			height: 40px;
			line-height: 40px;
			font-size: 16px;
		}
	}
</style>